import { render, staticRenderFns } from "./channelForm.vue?vue&type=template&id=5ab06763&scoped=true"
import script from "./channelForm.vue?vue&type=script&lang=js"
export * from "./channelForm.vue?vue&type=script&lang=js"
import style0 from "./channelForm.vue?vue&type=style&index=0&id=5ab06763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab06763",
  null
  
)

export default component.exports